// 任务
const state = {
    tmsFullDialog: false, // TMS同意全屏弹框
    accessButtons: '', // 记录用户按钮权限
    accessButtonsState: false,
  }

  const mutations = {
    tmsFullDialog(state, res) {
      state.tmsFullDialog = res
    },
    accessButtons(state, res) {
      state.accessButtons = res
    },
    accessButtonsState(state, res) {
      state.accessButtonsState = res
    },
  }

  export default {
    state,
    mutations
  }
